import React from 'react';
import logo from './logo.png';

export default function PendingPage() {
  return (
    <div style={{ minHeight: "100vh", background: "#0a0a0a", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', system-ui, sans-serif", position: "relative", overflow: "hidden", padding: "40px 24px" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700;900&family=DM+Serif+Display:ital@0;1&display=swap" rel="stylesheet" />

      <div style={{ position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)", backgroundSize: "48px 48px", pointerEvents: "none" }} />
      <div style={{ position: "absolute", top: "20%", left: "50%", transform: "translateX(-50%)", width: 600, height: 400, background: "radial-gradient(ellipse, rgba(220,38,38,0.08) 0%, transparent 70%)", pointerEvents: "none" }} />

      <div style={{ width: "100%", maxWidth: 460, position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 40, justifyContent: "center" }}>
          <img src={logo} style={{ width: 36, height: 36 }} alt="Binos" />
          <span style={{ fontWeight: 900, fontSize: 22, color: "#fff", letterSpacing: "-0.5px" }}>Binos</span>
        </div>

        <div style={{ background: "#161616", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 20, padding: "40px 32px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 20 }}>
            <div style={{ width: 8, height: 8, background: "#d97706", borderRadius: "50%", boxShadow: "0 0 8px rgba(217,119,6,0.6)" }} />
            <span style={{ fontSize: 11, fontWeight: 700, color: "#d97706", textTransform: "uppercase", letterSpacing: "0.12em" }}>Under Review</span>
          </div>

          <h1 style={{ fontFamily: "'DM Serif Display', Georgia, serif", fontSize: 30, fontWeight: 400, color: "#fff", margin: "0 0 12px", letterSpacing: "-0.5px" }}>Application received.</h1>
          <p style={{ fontSize: 14, color: "rgba(255,255,255,0.45)", lineHeight: 1.7, margin: "0 0 32px" }}>
            We review every application personally. You'll hear from us within <strong style={{ color: "#fff" }}>24 hours</strong>.
          </p>

          <div style={{ background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.05)", borderRadius: 12, padding: "20px" }}>
            <p style={{ fontSize: 10, fontWeight: 700, color: "rgba(255,255,255,0.25)", textTransform: "uppercase", letterSpacing: "0.12em", margin: "0 0 16px" }}>What happens next</p>
            {[
              "We review your fund profile",
              "You get an email — approved or not",
              "Approved funds get instant access",
            ].map((step, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: i < 2 ? 12 : 0 }}>
                <div style={{ width: 24, height: 24, background: "rgba(220,38,38,0.1)", border: "1px solid rgba(220,38,38,0.2)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 900, color: "#dc2626", flexShrink: 0 }}>{i + 1}</div>
                <p style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", margin: 0, lineHeight: 1.5 }}>{step}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: 24 }}>
          <a href="/" style={{ fontSize: 12, color: "rgba(255,255,255,0.2)", textDecoration: "none", fontWeight: 500 }}
            onMouseEnter={e => e.target.style.color = "rgba(255,255,255,0.5)"}
            onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.2)"}>
            ← Back to home
          </a>
        </div>
      </div>
    </div>
  );
}
